const TOKEN = "hc_cu_t";
const USERNAME = "hc_cu_u";
const CENTER = "hc_cu_c";

export let getToken = () => {
  let token = localStorage.getItem(TOKEN);
  if (!token) {
    token = "";
  }
  return token;
};

export let setToken = (token) => {
  localStorage.setItem(TOKEN, token);
};

export let getUsername = () => {
  let username = localStorage.getItem(USERNAME);
  if (!username) {
    username = "";
  }
  return username;
};

export let setUsername = (username) => {
  localStorage.setItem(USERNAME, username);
};

export let getCenter = () => {
  let center = localStorage.getItem(CENTER);
  if (!center) {
    center = "";
  }
  return center;
};

export let setCenter = (center) => {
  localStorage.setItem(CENTER, center);
};

export let clearStorage = () => {
  localStorage.clear();
};
